import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import SignIn from './SignIn';
import SignOut from './SignOut';
// import SignUp from 'pages/auth/SignUp';
import PasswordInquiry from 'pages/auth/PasswordInquiry';
import PasswordReset from 'pages/auth/PasswordReset';
import CodeRegistration from './CodeRegistration';
import { pageUrl } from 'lib/mapper';

function Auth() {
  return (
    <Switch>
      <Redirect exact path={pageUrl.auth.index} to={pageUrl.auth.codeRegistration} />
      <Route path={pageUrl.auth.codeRegistration} component={CodeRegistration} />
      <Route path={pageUrl.auth.signIn} component={SignIn} />
      <Route path={pageUrl.auth.signOut} component={SignOut} />
      <Route path={pageUrl.auth.passwordInquiry} component={PasswordInquiry} />
      <Route path={pageUrl.auth.passwordReset} component={PasswordReset} />
      {/* <Route path={pageUrl.auth.signUp} component={SignUp} /> */}
      <Route component={() => <Redirect to={pageUrl.error.notFound} />} />
    </Switch>
  );
}

export default Auth;
